import { Plus, X } from "lucide-react";
import ResumeSection from "@/components/resume/ResumeSection";

export default function SkillsSection({ skills = [], editing, onChange }) {
  const set = (next) => onChange(next);

  return (
    <ResumeSection
      title="Skills"
      index={2}
      action={
        editing && (
          <button
            type="button"
            onClick={() => set([...skills, "New skill"])}
            className="btn-ghost"
            data-testid="add-skill-button"
          >
            <Plus className="w-3.5 h-3.5" /> ADD
          </button>
        )
      }
    >
      {editing ? (
        <div className="space-y-2">
          {skills.map((s, i) => (
            <div key={`skill-${i}-${s.slice(0, 24)}`} className="flex gap-2">
              <input
                value={s}
                onChange={(e) => {
                  const list = [...skills];
                  list[i] = e.target.value;
                  set(list);
                }}
                className="swiss-input !p-2"
                data-testid={`edit-skill-${i}`}
              />
              <button
                type="button"
                onClick={() => set(skills.filter((_, idx) => idx !== i))}
                className="btn-ghost"
              >
                <X className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-wrap gap-2">
          {skills.map((s, i) => (
            <span
              key={`skill-tag-${i}-${s.slice(0, 24)}`}
              className="px-3 py-1 border border-[var(--border-default)] text-xs font-medium"
              data-testid={`skill-tag-${i}`}
            >
              {s}
            </span>
          ))}
        </div>
      )}
    </ResumeSection>
  );
}
